import React, { Fragment, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { fetchResetPassword } from "../actions/security";
import { useDispatch } from "react-redux";
import { Link, useNavigate, useParams } from "react-router-dom";
import Header from "../components/Header";
import { Button, TextField } from "@mui/material";
import { toast } from "react-toastify";
import CheckIcon from "@mui/icons-material/Check";

const SetNewPassword = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();

  const { t } = useTranslation(); // Koristi useTranslation za prevođenje

  const [state, setState] = useState({
    password: "",
    rePassword: "",
  });
  const [passwordConditions, setPasswordConditions] = useState({
    uppercase: false,
    minLength: false,
    number: false,
    specialChar: false,
  });

  const onChangeHandler = (event) => {
    const { name, value } = event.target;
    setState((prevUser) => ({
      ...prevUser,
      [name]: value,
    }));
  };

  // Funkcija koja proverava uslove lozinke
  const validatePassword = (password) => {
    const uppercaseRegex = /[A-Z]/;
    const numberRegex = /\d/;
    const specialCharRegex = /[!@#$%^&*(),.?":{}|<>]/;

    setPasswordConditions({
      uppercase: uppercaseRegex.test(password),
      minLength: password.length >= 8,
      number: numberRegex.test(password),
      specialChar: specialCharRegex.test(password),
    });
  };

  // Funkcija koja proverava da li su lozinke iste
  const handlePasswordChange = (event) => {
    onChangeHandler(event);
    if (event.target.name === "password") {
      validatePassword(event.target.value);
    }
  };

  const onSubmitHandler = (event) => {
    event.preventDefault();
    if (state.password !== state.rePassword) {
      toast.error(t("set_new_password.errors.passwords_do_not_match"), {
        theme: "colored",
      });
      return;
    }
    if (
      !passwordConditions.uppercase ||
      !passwordConditions.minLength ||
      !passwordConditions.number ||
      !passwordConditions.specialChar
    ) {
      toast.error(t("set_new_password.errors.invalid_password"), {
        theme: "colored",
      });
      return;
    }
    const items = {
      newPassword: state.password,
      accountLinkId: id,
    };
    dispatch(fetchResetPassword(items, navigate));
  };

  return (
    <Fragment>
      <Header nameClass={"backgorund-color-header"} />
      <div className="login-page-holder">
        <div className="login-page-image">
          <div className="login-page-image-title">
            <h1>{t("set_new_password.art_inspires_technology")}</h1>
            <h1>{t("set_new_password.technology_complements_art")}</h1>
          </div>
        </div>
        <div className="login-content-form">
          <h2>{t("set_new_password.join_and_participate")}</h2>
          <form onSubmit={onSubmitHandler}>
            <Row>
              <Col xs={12}>
                <TextField
                  type="password"
                  variant="standard"
                  required
                  label={t("set_new_password.password")}
                  name="password"
                  value={state.password}
                  onChange={handlePasswordChange}
                  fullWidth
                  size="small"
                  className="input-field-form mb-3"
                />
              </Col>
              <Col xs={12} className="passowrd-holder-item">
                <TextField
                  type="password"
                  variant="standard"
                  required
                  label={t("set_new_password.repeat_password")}
                  name="rePassword"
                  value={state.rePassword}
                  onChange={onChangeHandler}
                  fullWidth
                  size="small"
                  className="input-field-form"
                />
                <div className="holder-password-required-items mt-3">
                  <div className="info-password-required">
                    <div
                      className={`info-password-required-text ${
                        passwordConditions.uppercase
                          ? "check-required-success"
                          : ""
                      }`}
                    >
                      <CheckIcon />{" "}
                      {t("set_new_password.password_requirements.uppercase")}
                    </div>
                    <div
                      className={`info-password-required-text ${
                        passwordConditions.minLength
                          ? "check-required-success"
                          : ""
                      }`}
                    >
                      <CheckIcon />{" "}
                      {t("set_new_password.password_requirements.min_length")}
                    </div>
                    <div
                      className={`info-password-required-text ${
                        passwordConditions.number
                          ? "check-required-success"
                          : ""
                      }`}
                    >
                      <CheckIcon />{" "}
                      {t("set_new_password.password_requirements.number")}
                    </div>
                    <div
                      className={`info-password-required-text ${
                        passwordConditions.specialChar
                          ? "check-required-success"
                          : ""
                      }`}
                    >
                      <CheckIcon />{" "}
                      {t("set_new_password.password_requirements.special_char")}
                    </div>
                  </div>
                </div>
              </Col>
              <Col className="login-button-item">
                <Button type="submit">
                  {t("set_new_password.save_new_password")}
                </Button>
              </Col>
            </Row>
          </form>
          <div className="registration-section-login-page d-flex justify-content-between align-items-center">
            <div className="registration-button">
              <Link to="/login">{t("set_new_password.login")}</Link>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default SetNewPassword;
